import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {DIRTY_POLL_INTERVAL} from '../consts'
import {ExpertSystemEquipmentType, YearlyKpiValue, YearlyKpiValueQueryKey} from '../types'

export const useYearlyKpiValue = (
  kpiTargetEquipmentType: ExpertSystemEquipmentType,
  year: number,
  options?: Omit<UseQueryOptions<YearlyKpiValue[], AxiosError>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<YearlyKpiValue[], AxiosError>({
    queryKey: [YearlyKpiValueQueryKey, kpiTargetEquipmentType, year],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<YearlyKpiValue[]>(
        `/expert-system/kpis/${kpiTargetEquipmentType}/yearly/${year}`,
        {
          signal
        }
      )
      return response.data
    },
    select: (data) =>
      data.map((item) => ({
        ...item,
        ...(item.value !== undefined && {value: Math.round(item.value)})
      })),
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    refetchInterval: (query) => {
      const data = query.state.data
      if (!data) return DIRTY_POLL_INTERVAL
      const hasDirty = Object.values(data).some((year) => year.isDirty)
      return hasDirty && DIRTY_POLL_INTERVAL
    },
    ...options
  })
}
